import { useMutation, gql, UseMutationResponse } from 'urql';

import { Team } from '@wetransfer/transfer/hooks/useCurrentTeam/useCurrentUserTeamsQuery';

const CreateTeamForOwnAccountMutation = gql`
  mutation {
    createTeamForOwnAccount {
      team {
        id
      }
      errors
    }
  }
`;

export interface CreateTeamForOwnAccountMutationResponse {
  createTeamForOwnAccount: {
    team: Team;
    errors: string[];
  };
}

export function useCreateTeamForOwnAccountMutation(): UseMutationResponse<CreateTeamForOwnAccountMutationResponse> {
  const [result, createTeamForOwnAccount] =
    useMutation<CreateTeamForOwnAccountMutationResponse>(
      CreateTeamForOwnAccountMutation
    );

  return [result, createTeamForOwnAccount];
}
